<template lang="pug" src="./template/CategoriesFilter.pug"></template>
<style lang="stylus" src="./styles/CategoriesFilter.styl" scoped></style>

<script>
import SwitchButton from '../components/SwitchButton';

export default {
    components: { SwitchButton },

    data() {
        return {
            categories: [],
            activeFilters: {},
            show: false,
        };
	},

    async mounted() {
        this.categories = await this.getCategories();
        if (this.$route.query.category) {
            let categories = JSON.parse(this.$route.query.category);
            for (let elem of categories) {
                this.activeFilters[elem] = true;
            }
        }
    },

    methods: {
        async getCategories() {
			const response = await window.axios.get('/api/categories/');
            return response.data.data;
		},

		toggleCategoriesFilter() {
            const searchTerms = this.$route.query.search;
            const categories = Object.keys(this.activeFilters).filter((k) => this.activeFilters[k]);
            const category = JSON.stringify(categories);

            this.$router.push({ query: { search: searchTerms, category: category } });
             
			this.$store.dispatch('toggleCategoriesFilter', Object.keys(this.activeFilters).filter((k) => this.activeFilters[k]));
		},
    },

};
</script>
